import { fetcher } from '@commenda/utils';
import { readErrorMessage } from '../../workflow-template/helpers';
import {
  CreateTransferPricingBenchmarkParams,
  CreateTransferPricingBenchmarkResponse,
} from './types';

type CreateTransferPricingBenchmarkResult =
  | { ok: true; data: CreateTransferPricingBenchmarkResponse; error?: never }
  /** `error` is the server's reason when it gave one. */
  | { ok: false; error: string | undefined };

const createTransferPricingBenchmark = async (
  body: CreateTransferPricingBenchmarkParams
): Promise<CreateTransferPricingBenchmarkResult> => {
  const res = await fetcher('transfer-pricing/benchmark', {
    method: 'POST',
    body,
  });

  if (!res.ok) {
    return { ok: false, error: await readErrorMessage(res) };
  }

  const data = (await res.json()) as CreateTransferPricingBenchmarkResponse;
  return { ok: true, data };
};

export { createTransferPricingBenchmark };
export type { CreateTransferPricingBenchmarkResult };
